import { render, staticRenderFns } from "./menuItemsCard.vue?vue&type=template&id=71701e4a&scoped=true"
import script from "./menuItemsCard.vue?vue&type=script&lang=js"
export * from "./menuItemsCard.vue?vue&type=script&lang=js"
import style0 from "./menuItemsCard.vue?vue&type=style&index=0&id=71701e4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71701e4a",
  null
  
)

export default component.exports